<template>
    <div class="horizontalScreen" type="false">
        <headers></headers>
        <!-- <div class="main"> -->
            <img :src="$t('pcagenda').src" alt="" class="agenda">
        <!-- </div> -->
        <div class="footer">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
    </div>
</template>

<script>
    import headers from "../../components/headers.vue"
    export default {
        components: {
            headers
        },
        name: 'pcagenda',
        data() {
            return {
                lang: ""
            }
        },
        created() {
            let lang = localStorage.getItem("lang");
            this.$i18n.locale = this.lang = lang;
        },
        mounted() {

        },
        methods: {}
    }
</script>
<style scoped>
    .waiting {
        text-align: center;
    }
    
    .waiting img {
        width: 152px;
        margin: 0 auto 35px;
        height: auto;
        display: inline-block;
    }
    
    .waiting_text {
        text-align: center;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(0deg, #FF6900 0%, #CC2200 100%);
        /* margin-bottom: 130px; */
        font-size: 30px;
        font-weight: bold;
    }
    .agenda{
        width: 1180px;
        display: block;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/views/pc/agenda.vue